
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.75 6.05h3.3v-3.3h-3.3v3.3zm4.8.15A1.35 1.35 0 016.2 7.55H2.6A1.35 1.35 0 011.25 6.2V2.6c0-.746.604-1.35 1.35-1.35h3.6c.746 0 1.35.604 1.35 1.35v3.6zM9.95 6.05h3.3v-3.3h-3.3v3.3zm4.8.15a1.35 1.35 0 01-1.35 1.35H9.8A1.35 1.35 0 018.45 6.2V2.6c0-.746.604-1.35 1.35-1.35h3.6c.746 0 1.35.604 1.35 1.35v3.6zM2.75 13.25h3.3v-3.3h-3.3v3.3zm4.8.15a1.35 1.35 0 01-1.35 1.35H2.6a1.35 1.35 0 01-1.35-1.35V9.8c0-.746.604-1.35 1.35-1.35h3.6c.746 0 1.35.604 1.35 1.35v3.6zM9.95 13.25h3.3v-3.3h-3.3v3.3zm4.8.15a1.35 1.35 0 01-1.35 1.35H9.8a1.35 1.35 0 01-1.35-1.35V9.8c0-.746.604-1.35 1.35-1.35h3.6c.746 0 1.35.604 1.35 1.35v3.6z","fill":"#4A4A4A"}})])
          )
        }
      }
    